export type ReasonTypes =
  | 'wrong-category'
  | 'wrong-master'
  | 'fake-listing'
  | 'no-intent-to-sell'
  | 'other-reason'
  | '';
export const REASONS: { id: string; label: string; value: ReasonTypes }[] = [
  {
    id: '2',
    label: 'Wrong Category',
    value: 'wrong-category',
  },
  {
    id: '3',
    label: 'Wrong Master Model',
    value: 'wrong-master',
  },
  {
    id: '4',
    label: 'Fake Listing',
    value: 'fake-listing',
  },
  {
    id: '5',
    label: 'No Intent To Sell',
    value: 'no-intent-to-sell',
  },
  {
    id: '6',
    label: 'Other Reason',
    value: 'other-reason',
  }
];
